import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=e18dc234&scoped=true&lang=pug"
import script from "./productForm.vue?vue&type=script&lang=js"
export * from "./productForm.vue?vue&type=script&lang=js"
import style0 from "./productForm.vue?vue&type=style&index=0&id=e18dc234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18dc234",
  null
  
)

export default component.exports